import { useQuery } from 'villus';
import { RetailersDocument } from '~/graphql/Retailers';

export const useRetailers = () => {
  const { execute } = useQuery({
    query: RetailersDocument.toString(),
    fetchOnMount: false,
  });

  const { data } = useAsyncData('retailers', async () => {
    const { data, error } = await execute();

    if (error) {
      console.error('Error fetching retailers:', error);
      return [];
    }

    return data?.retailers?.items || [];
  });

  return {
    retailers: data,
  };
};
